import React, { forwardRef } from 'react';

import MUIStepLabel, {
  StepLabelProps as MUIStepLabelProps,
} from '@material-ui/core/StepLabel';

interface StepLabelProps extends MUIStepLabelProps {}

const StepLabel = forwardRef<HTMLSpanElement, StepLabelProps>((props, ref) => {
  return <MUIStepLabel {...props} ref={ref} />;
});

StepLabel.displayName = 'StepLabel';

export default StepLabel;
